import { render, staticRenderFns } from "./FavoritesMenu.vue?vue&type=template&id=55ccc536&"
import script from "./favoritesMenu.js?vue&type=script&lang=js&"
export * from "./favoritesMenu.js?vue&type=script&lang=js&"
import style0 from "./FavoritesMenu.vue?vue&type=style&index=0&id=55ccc536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports